<template>
  <BModal
    ref="modalAuthorityToWithdraw"
    size="xl"
    scrollable
    hide-header
    no-enforce-focus
    no-close-on-backdrop
    content-class="scrollable-tabs"
    modal-class="full-height modal-no-padding"
    aria-hidden="false"
    role="dialog"
  >
    <BTabs
      active-nav-item-class="font-weight-bold text-uppercase text-primary"
      content-class="scrollable"
    >
      <BTab class="p-2">
        <template #title>
          <div class="text-md-nowrap">
            <i class="fa-lg fad fa-file-lines mr-1" />
            <b class="is-tab-active">Authority To Withdraws</b>
          </div>
        </template>
        <BRow class="gap-y-2">
          <BCol
            cols="12"
            md="8"
          >
            <BFormGroup
              label="Search"
              label-for="filterWithdrawalSearch"
              label-class="font-weight-bolder"
            >
              <BFormInput
                id="filterWithdrawalSearch"
                v-model="tableWithdrawals.filter.search"
                placeholder="search here"
                autocomplete="off"
                debounce="1000"
                type="text"
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="6"
            md="2"
          >
            <BFormGroup
              label="Requested From"
              label-for="filterWithdrawalDateFrom"
              label-class="font-weight-bolder"
            >
              <BFormInput
                id="filterWithdrawalDateFrom"
                v-model="tableWithdrawals.filter.date_from"
                :max="tableWithdrawals.filter.date_to"
                debounce="1000"
                type="date"
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="6"
            md="2"
          >
            <BFormGroup
              label="Requested To"
              label-for="filterWithdrawalDateTo"
              label-class="font-weight-bolder"
            >
              <BFormInput
                id="filterWithdrawalDateTo"
                v-model="tableWithdrawals.filter.date_to"
                :min="tableWithdrawals.filter.date_from"
                debounce="1000"
                type="date"
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
          >
            <CustomTable
              ref="tableWithdrawals"
              :provider="tableProvider"
              :busy="tableWithdrawals.busy"
              :filter="tableWithdrawals.filter"
              :fields="tableWithdrawals.fields"
              :stacked="tableWithdrawals.stacked"
              :sort-by.sync="tableWithdrawals.sortBy"
              :sort-desc.sync="tableWithdrawals.sortDesc"
              :sort-direction="tableWithdrawals.sortDirection"
              :filter-included-fields="tableWithdrawals.filterOn"
              :current-page="tableWithdrawals.currentPage"
              :total-rows="tableWithdrawals.totalRows"
              :per-page="tableWithdrawals.perPage"
            >
              <template #row-details="row">
                <div class="p-2 bg-white">
                  <BTable
                    small
                    hover
                    bordered
                    responsive
                    show-empty
                    class="col-md-6 col-12"
                    :stacked="tableWithdrawals.stacked"
                    :items="row.item.approvable.withdrawal_details"
                    :fields="[
                      { key: 'index', label: '#', class: 'text-center' },
                      { key: 'product_name', label: 'Product Name', class: 'col-md-6 col-12' },
                      { key: 'quantity', class: 'text-center min-w-100px' }
                    ]"
                  >
                    <template #cell(index)="{ index }">
                      <div style="min-width: 25px;">
                        {{ tableRowNumber(tableWithdrawals, index) }}
                      </div>
                    </template>

                    <template #cell(quantity)="{ value }">
                      <div class="text-md-nowrap d-flex justify-content-center align-items-center min-h-35px">
                        <strong
                          class="font-weight-bolder"
                          v-text="numberFormatter(value, '0,0')"
                        />
                      </div>
                    </template>
                  </BTable>
                </div>
              </template>

              <template #cell(action)="{ item, toggleDetails, detailsShowing }">
                <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-md-start justify-content-center gap-1">
                  <BOverlay
                    :show="String(item.id) === String(tableWithdrawals.selectedRow)"
                    rounded="sm"
                    opacity="0.6"
                    spinner-small
                    spinner-variant="warning"
                  >
                    <BButton
                      size="sm"
                      variant="primary"
                      :disabled="tableWithdrawals.busy"
                      @click.prevent="edit(item)"
                    >
                      Edit As Transfer
                    </BButton>
                  </BOverlay>
                  <BButton
                    size="sm"
                    :variant="detailsShowing ? 'danger' : 'warning' "
                    :disabled="tableWithdrawals.busy"
                    @click.prevent="toggleDetails"
                  >
                    {{ detailsShowing ? 'Hide' : 'Show' }} Products
                  </BButton>
                </div>
              </template>

            </CustomTable>
          </BCol>
        </BRow>
      </BTab>
    </BTabs>
    <template #modal-footer="{ cancel }">
      <div>
        <BButton
          variant="outline-dark"
          @click.prevent="$event => {
            $event.target.blur()
            cancel()
          }"
        >
          Close <span class="d-none d-md-inline-block">Window</span>
        </BButton>
      </div>
    </template>
  </BModal>
</template>
<script>
import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'

import { SProductionATWReceiving } from '@/services/user/prd'

export default {
  name: 'AuthorityToWithdraw',

  mixins: [
    MISC,
    FORMATTER
  ],

  data () {
    return {
      tableWithdrawals: {
        busy: false,
        selectedRow: '',
        filter: {
          search: '',
          date_from: '',
          date_to: ''
        },
        filterOn: [],
        stacked: this.isMobile(),
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 5, key: 'action', class: 'text-center' },
          { mobile: 1, key: 'approvable.created_at', label: 'Transferred At', class: 'min-w-175px', formatter: this.dateTimeShortFormatter, sortable: true },
          { mobile: 2, key: 'approvable.transaction_number', label: 'Transaction Number', class: 'text-center min-w-150px', sortable: true },
          { mobile: 3, key: 'approvable.origin_name', label: 'Withdrawal From', class: 'min-w-200px' },
          { mobile: 4, key: 'approvable.withdrawal_details.length', label: 'Products', class: 'text-center' }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  methods: {
    async tableProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableWithdrawals.busy = true
      return SProductionATWReceiving.histories({
        page: currentPage,
        per_page: perPage,
        sort: sortBy,
        sort_desc: sortDesc,
        filter_text: filter.search,
        filter_date_from: filter.date_from,
        filter_date_to: filter.date_to,
        is_used: 0
      }).then(
        ({ data }) => {
          this.tableWithdrawals.totalRows = data.total_rows
          return data.items
        }
      ).catch(() => {
        this.tableWithdrawals.totalRows = 0
        return []
      }).finally(() => {
        this.tableWithdrawals.busy = false
      })
    },

    edit (withdrawal) {
      this.tableWithdrawals.selectedRow = withdrawal.id
      this.$emit('edit', withdrawal, () => {
        this.tableWithdrawals.selectedRow = ''
      })
    },

    showModal () {
      this.$refs.modalAuthorityToWithdraw.show()
    },

    hideModal () {
      this.$refs.modalAuthorityToWithdraw.hide()
    }
  }
}
</script>
